import { render, staticRenderFns } from "./personnel-grow.vue?vue&type=template&id=d5d80af4&scoped=true&"
import script from "./personnel-grow.vue?vue&type=script&lang=js&"
export * from "./personnel-grow.vue?vue&type=script&lang=js&"
import style0 from "./personnel-grow.vue?vue&type=style&index=0&id=d5d80af4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5d80af4",
  null
  
)

export default component.exports